<fhm-page [title]="title" [showSave]="true"
          (doneClicked)="done()"
          (saveClicked)="save()"
          [description]="'fhm.user.description'">
    <fui-rows [formGroup]="formGroup">
        <fui-row>
            <fui-two-columns>

                <fui-column>
                    <fui-select-control formControlName="role"
                                        [control]="formGroup.get('role')"
                                        [options]="options"
                                        [(value)]="role"
                                        [labelField]="'label'"
                                        [label]="'fhm.user.role.label'"
                                        [loading]="false"
                                        [valueField]="'value'"
                                        [internallyFilterable]="true"
                                        [allowClearSelectionOption]="false"
                                        [showExtendedSearchOption]="false"
                                        [removable]="false"
                                        [showAddOption]="false">
                    </fui-select-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </fui-rows>
</fhm-page>
